// Implements: F-IDN-026
/**
 * The addresses typed into "Invitar personas" (v3 `openInvite`): one or several, separated by
 * commas, semicolons, spaces or new lines. Each is lowercased and repeats are dropped, so one
 * address never makes two invitations; what does not look like an address is named back to the
 * person instead of being sent. The server still validates every address it receives.
 */

export interface ParsedEmails {
  readonly valid: string[];
  readonly invalid: string[];
}

const SEPARATORS = /[\s,;]+/;
/** The v3 mockup's own check: something, one `@`, a domain with a dot and a 2+ letter ending. */
const ADDRESS = /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i;

export function parseInvitationEmails(raw: string): ParsedEmails {
  const valid: string[] = [];
  const invalid: string[] = [];
  for (const piece of raw.split(SEPARATORS)) {
    const address = piece.trim().toLowerCase();
    if (address === "") continue;
    const bucket = ADDRESS.test(address) ? valid : invalid;
    if (!bucket.includes(address)) bucket.push(address);
  }
  return { valid, invalid };
}
